import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface AppNotification {
  id: string;
  type: 'host_transfer_request' | 'general';
  title: string;
  message: string;
  event_id?: string;
  event_name?: string;
  from_user_id?: string;
  from_user_name?: string;
  from_user_email?: string;
  host_id?: string;
  transition_request_id?: string;
  user_name?: string;
  created_at?: any;
  read: boolean;
  eventStorageSize?: {
    event_size_bytes?: number | null;
    available?: boolean;
    available_bytes?: number | null;
    user_plan_id?: number | null;
    user_add_on_id?: number | null;
    recommended_plan_name?: string | null;
  } | null;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private _notifications = new BehaviorSubject<AppNotification[]>([]);
  notifications$ = this._notifications.asObservable();

  get unreadCount(): number {
    return this._notifications.value.filter(n => !n.read).length;
  }

  setNotifications(notifications: AppNotification[]) {
    this._notifications.next(notifications);
  }

  markAllRead() {
    const updated = this._notifications.value.map(n => ({ ...n, read: true }));
    this._notifications.next(updated);
  }

  markRead(id: string) {
    const updated = this._notifications.value.map(n =>
      n.id === id ? { ...n, read: true } : n
    );
    this._notifications.next(updated);
  }

  remove(id: string) {
    const updated = this._notifications.value.filter(n => n.id !== id);
    this._notifications.next(updated);
  }
}
